export const isEmpty = (obj: Object) => Object.getOwnPropertyNames(obj).length === 0;
